import magnifiAPIInstance from "./apiInstance";

export const webStoryAPIs = {
  getWebStoryDetails: ({ payload }) => magnifiAPIInstance.post(`/get-story-details`, payload),
  editWebStoryStoryClip: ({ payload }) => magnifiAPIInstance.post(`/add-story`, payload),
  getWebStoriesByOrganization: ({ payload }) => magnifiAPIInstance.post(`/get-stories-by-organization`, payload),
  createWebStory: ({ payload }) => magnifiAPIInstance.post(`/create-webstory`, payload),
  publishWebStory: ({ payload }) => magnifiAPIInstance.post(`/republish-story`, payload),
};
